// extracted by mini-css-extract-plugin
export var cardContainer = "_nx-0";
export var cardHeader = "_nx-2";
export var collapsedState = "_nx-3";
export var dragHandle = "_nx-5";
export var dragHandleIcon = "_nx-6";
export var dragging = "_nx-1";
export var titleArea = "_nx-4";